import { jsx as a } from "react/jsx-runtime";
import { c as s } from "../../index-C7ezJk5b.js";
import "../../base-nYmjnkiN.js";
import "react";
import { cssX as o } from "../../core/utils/css.js";
import "react-dom";
import '../../assets/Wrapper.css';/* empty css                     */
import "react-router-dom";
const h = ({
  data: r,
  testId: i,
  style: m,
  className: n,
  ...p
}) => /* @__PURE__ */ a(
  "div",
  {
    className: s(o("Navigation"), n),
    style: m,
    "data-testid": i,
    ...p,
    children: r.map((t) => /* @__PURE__ */ a(
      "div",
      {
        className: o("Navigation__item"),
        "data-testid": i ? `${i}Item` : void 0,
        children: t.content
      },
      t.id
    ))
  }
);
export {
  h as default
};
